module.exports = __webpack_public_path__ + "img/no-authority.b9bb4aca.png";